<template>
  <div
      v-if="Object.keys(main_sim_state).length > 0"
      class="state"
  >
    <span
        class="sphere mdi mdi-check-circle-outline"
        :style="'background-color:' + main_sim_state.color"
    />
    <span
        v-if="Number(sim_state.temp) >= min_temp"
        class="temp mdi mdi-thermometer"
        :class="{
          temp_yellow: Number(sim_state.temp) >= min_temp && Number(sim_state.temp) < max_temp,
          temp_red: Number(sim_state.temp) >= max_temp
        }"
    />
  </div>
</template>
<script>
export default {
  name: "SimState",
  props: {
    sim_state:{
      type: Object
    }
  },
  data() {
    return {
      min_temp: 85,
      max_temp: 90
    };
  },
  computed:{
    main_sim_state(){
      return this.sim_state ? this.sim_state : {}
    }
  },
  methods:{

  }
}

</script>

<style lang="scss" scoped>
.state{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .sphere{
    width: 18px;
    height: 18px;
    position: relative;
    &.mdi {
      width: 18px;
      height: 18px;
      &::before{
        position: absolute;
        font-size: 22px;
        color: black;
        width: 100%;
        height: 100%;
        top: 2px;
        left: -2px;
      }
    }
  }
  .temp{
    width: 18px;
    height: 18px;
    font-size: 18px;
    &.temp_yellow{
      color: #dfce53;
    }
    &.temp_red{
      color: #fd3e3e;
    }
  }
}


</style>
